export enum GlobalActions {
    SET_IS_ISSUING_CARD = 'SET_IS_ISSUING_CARD',
    SET_IS_SERVICABLE = 'SET_IS_SERVICABLE',
    SET_IS_UPDATE_AVAILABLE = 'SET_IS_UPDATE_AVAILABLE',
    SET_SHOW_PARTICIPANT_JOINED_MODAL = 'SET_SHOW_PARTICIPANT_JOINED_MODAL',
    SET_SHOULD_IGNORE_AVAILABLE_UPDATE = 'SET_SHOULD_IGNORE_AVAILABLE_UPDATE'
}

interface SetIsIssuingCard {
    type: typeof GlobalActions.SET_IS_ISSUING_CARD,
    payload: boolean,
}

interface SetIsServicable {
    type: typeof GlobalActions.SET_IS_SERVICABLE,
    payload: boolean,
}

interface SetIsUpdateAvailable {
    type: typeof GlobalActions.SET_IS_UPDATE_AVAILABLE
    payload: {
        isAvailable: boolean
        isCritical: boolean
    }
}

interface SetShouldIgnoreAvailableUpdate {
    type: typeof GlobalActions.SET_SHOULD_IGNORE_AVAILABLE_UPDATE,
    payload: boolean
}

interface SetShowParticipantJoinedModal {
    type: typeof GlobalActions.SET_SHOW_PARTICIPANT_JOINED_MODAL,
    payload: boolean,
}

export type GlobalActionTypes = (
    SetIsIssuingCard |
    SetIsServicable |
    SetIsUpdateAvailable |
    SetShouldIgnoreAvailableUpdate |
    SetShowParticipantJoinedModal
)
